// main.js
import { createApp } from 'vue';
import App from './App.vue';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import router from './router/index.js';
import '../scss/main.css';
import store from './components/js/store.js';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import axios from 'axios';

let appInstance = null;

axios.get('/config.txt')
    .then(response => {
        // 텍스트 파일 내용을 줄 단위로 분할
        const lines = response.data.split('\n');
        const envVars = {};

        // 각 줄을 환경 변수로 설정
        lines.forEach(line => {
            const [key, value] = line.split('=');
            if (key && value) {
                envVars[`$${key.trim()}`] = value.trim();
            }
        });

        // Vue 애플리케이션 초기화
        appInstance = initializeApp(envVars);
    })
    .catch(error => {
        console.error('Failed to load config file:', error);
        // 설정 파일을 읽지 못한 경우, 빈 환경 변수로 앱을 초기화할 수도 있습니다.
        appInstance = initializeApp({});
    });

function initializeApp(envVars) {
    // Vue 애플리케이션 생성
    const app = createApp(App);

    // 환경 변수를 globalProperties에 설정
    Object.keys(envVars).forEach(key => {
        app.config.globalProperties[key] = envVars[key];
    });

    // 전역 컴포넌트 등록
    app.component("modal", {
        template: "#modal-template"
    });

    // 라우터 및 플러그인 사용
    app.use(router); // 라우터 사용
    app.use(store); // Vuex 스토어 사용
    app.use(VueSweetalert2);

    // Vue 애플리케이션 마운트
    // (서버 URL/도메인 콘솔 출력 제거 — IP 노출 방지)

    // app.mount('#app'); // Initialize app with a specific element ID
    return app; // 애플리케이션 인스턴스를 반환
}

function mountApp() {
    if (appInstance) {
        appInstance.mount('#app'); // Mount the app only when it's initialized
    } else {
        console.error('App is not initialized yet.');
    }
}

// Start app mounting once configuration is loaded
axios.get('/config.txt')
    .then(() => {
        mountApp();
    })
    .catch(() => {
        mountApp(); // Optionally handle errors and still attempt to mount app
    });

export function getApp() {
    if (!appInstance) {
        throw new Error('App is not initialized yet.');
    }
    return appInstance;
}
